import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Table, Row, Col, Button, Checkbox, notification, Spin } from 'antd';
import { components, unexpectedError } from '../../../common_functions';

const TabsPermissions = props => {
  const { section, id } = useParams();
  const [collPermissions, setCollPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [permissionData, setpermissionData] = useState([]);
  const [isDisabled, setDisabled] = useState(true);

  //Get collection data
  useEffect(() => {
    (async () => {
    props.tabActiveKey == '2' && (await getColData());
  })();
  }, [props.tabActiveKey]);

  const getColData = async () => {
    try {
      setLoading(true);
      let { data } = await props.getItems('users_tabs_permissions', {
        fields: ['id,user_id,entity.id,entity.name,create,edit,view,delete,all'],
        filters: { user_id: { _eq: id } },
        sort: 'entity.name',
      });
      data = data.map(item => {
        return {
          user_id: item.user_id,
          entity_id: item.entity.id,
          create: item.create,
          view: item.view,
          edit: item.edit,
          delete: item.delete,
          all: item.all,
          id: item.id,
          name: item.entity.name,
        };
      });
      setpermissionData(data);
      setCollPermissions(data);
    } catch (error) {
      console.log(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  let columns = [
    {
      title: 'Entity',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{text}</span>,
    },
    {
      title: 'Create',
      dataIndex: 'create',
      key: 'create',
      render: (text, record) => (
        <span>
          <Checkbox value={record.id} onChange={e => handlePermissions(e, record, 'create')} checked={!!record.create}></Checkbox>
        </span>
      ),
    },
    {
      title: 'Read',
      dataIndex: 'view',
      key: 'view',
      render: (text, record) => (
        <span>
          <Checkbox onChange={e => handlePermissions(e, record, 'view')} checked={!!record.view}></Checkbox>
        </span>
      ),
    },
    {
      title: 'Edit',
      dataIndex: 'edit',
      key: 'edit',
      render: (text, record) => (
        <span>
          <Checkbox onChange={e => handlePermissions(e, record, 'edit')} checked={!!record.edit}></Checkbox>
        </span>
      ),
    },
    {
      title: 'Delete',
      dataIndex: 'delete',
      key: 'delete',
      render: (text, record) => (
        <span>
          {record.name === 'settings - configuration' ? (
            <Checkbox disabled />
          ) : (
            <Checkbox value={record.id} onChange={e => handlePermissions(e, record, 'delete')} checked={!!record.delete}></Checkbox>
          )}
        </span>
      ),
    },
    {
      title: 'All',
      dataIndex: 'all',
      key: 'all',
      render: (text, record) => (
        <span>
          {record.name === 'settings - configuration' ? (
            <Checkbox disabled />
          ) : (
            <Checkbox value={record.id} onChange={e => handlePermissions(e, record, 'all')} checked={!!record.all}></Checkbox>
          )}
        </span>
      ),
    },
  ];

  const handlePermissions = async (event, record, permission) => {
    setDisabled(false);
    let checked = event.target.checked;
    let permissionObj = managePermissions(permission, checked);
    let newData = collPermissions.map(obj => {
      if (obj.id == record.id) {
        obj = {
          ...obj,
          ...permissionObj,
        };
        // if view, edit, delete checked then "all" checked
        obj.all = obj.view && obj.edit && obj.delete && obj.create;
      }
      return obj;
    });
    setCollPermissions(newData);
  };

  const managePermissions = (permission, checked) => {
    switch (permission) {
      case 'all':
        return {
          all: checked,
          view: checked,
          edit: checked,
          delete: checked,
          create: checked,
        };
      case 'view':
        return !!checked
          ? { view: checked }
          : {
              view: checked,
              create: checked,
              edit: checked,
              all: checked,
              delete: checked,
            };
      case 'edit':
        return !!checked ? { edit: checked, view: checked } : { edit: checked, all: checked };
      case 'create':
        return !!checked ? { create: checked, view: checked } : { create: checked, all: checked };
      case 'delete':
        return !!checked ? { delete: checked, view: checked } : { delete: checked, all: checked };
      default:
        return {};
    }
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      const updateData = collPermissions.filter(item_1 => {
        return !permissionData.some(
          item_2 =>
            item_2.id == item_1.id &&
            item_2.all == item_1.all &&
            item_2.view == item_1.view &&
            item_2.edit == item_1.edit &&
            item_2.delete == item_1.delete &&
            item_2.create == item_1.create
        );
      });
      await props.saveBatchItems('users_tabs_permissions', updateData);
      await getColData();
      setDisabled(true);
      notification['success']({
        message: 'Other permissions saved successfully!',
        duration: 2,
      });
    } catch (error) {
      console.log(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading} size="large">
      <div className="artist-list">
        <Table
          className="no-fixed-last-col"
          scroll={{ x: 'max-content' }}
          columns={columns}
          bordered
          rowKey={record => record.id}
          dataSource={collPermissions}
          pagination={false}
          loading={loading}
          components={components}
        />
        <Row gutter={24} className="page-header-section" align="middle" style={{ marginTop: '20px' }}>
          <Col xs={12}>
            <Button
              type="default"
              htmlType="button"
              onClick={() => props.handleTabChange('1')}
              style={{
                borderColor: '#d9d9d9',
                background: '#f5f5f5',
                color: 'rgba(0, 0, 0, 0.85)',
              }}
            >
              Back
            </Button>

            <Button
              disabled={isDisabled}
              className="save-btn"
              type="primary"
              style={{ margin: '0 8px' }}
              htmlType="button"
              onClick={onFinish}
            >
              Save Permissions
            </Button>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};

export default TabsPermissions;
